module.exports = __webpack_public_path__ + "static/img/cat-in-a-box.f9615ad0.png";